module.exports = __webpack_public_path__ + "img/vertical_4_6_9006.ee3f45b0.png";